/**
 * Given the glossary from user service, looks up the term with the given ID and returns an ITranslatable of that term's description
 *
 * @param glossary
 * @param id
 * @returns ITranslatable
 */
const getGlossaryTermById = (glossary, id) => {
    const matchedTerm = glossary?.filter((glossaryItem) => {
        if (glossaryItem.uniqueId === id) {
            return glossaryItem;
        }
    });
    if (matchedTerm && matchedTerm.length === 1) {
        return {
            english: matchedTerm[0].fieldValueDescription_EN,
            spanish: matchedTerm[0].fieldValueDescription_ES,
        };
    }
    else {
        //something went wrong, tooltip unavailable so return empty strings
        return { english: '', spanish: '' };
    }
};
export default getGlossaryTermById;
